import React from "react";
import Text from "./AppText";
import tw from "twrnc";

const FormSubtitle = ({ style, children }) => {
  return (
    <Text
      style={[
        tw`text-[#2e3f52] text-[14px] font-normal text-left mt-[15px] mb-1 web:block web:tracking-normal web:leading-normal`,
        style,
      ]}
    >
      {children}
    </Text>
  );
};

export default FormSubtitle;
